var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"border":"1px solid #000","max-width":"160px","object-fit":"contain"},attrs:{"src":_vm.imageUrl,"loading":"lazy","decoding":"async","height":"40","alt":""},on:{"error":_vm.useOriginal}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /Users/liujiahua/PycharmProjects/vue-project/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b71cdf2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/Users/liujiahua/PycharmProjects/vue-project/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OssThumbnail.vue
// module id = null
// module chunks = 